import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import { z } from "zod";
import {
    addParakeyIntegrationCommandIdFactory,
    addParakeyIntegrationCommandIdZodSchema,
} from "./add-parakey-integration-command-id";

type AddLockyIntegrationCommand = {
    _id: string;
    _createdAt: IsoAndUnixTimestamp;
    _type: "ADD_LOCKY_INTEGRATION_COMMAND";
    providerId: ProviderId;
    jwtToken: string;
    serverUrl: string;
};

type FactoryParams = Except<
    AddLockyIntegrationCommand,
    "_id" | "_type" | "_createdAt"
>;
const addLockyIntegrationCommandFactory = (params: FactoryParams) => {
    const command: AddLockyIntegrationCommand = {
        ...params,
        _id: addParakeyIntegrationCommandIdFactory(),
        _type: "ADD_LOCKY_INTEGRATION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const addLockyIntegrationCommandZodSchema: z.ZodSchema<AddLockyIntegrationCommand> =
    z.object({
        _id: addParakeyIntegrationCommandIdZodSchema,
        _type: z.literal("ADD_LOCKY_INTEGRATION_COMMAND"),
        _createdAt: isoAndUnixZodSchema,

        providerId: providerIdZodSchema,
        jwtToken: z.string(),
        serverUrl: z.string(),
    });

export {
    addLockyIntegrationCommandFactory,
    addLockyIntegrationCommandZodSchema,
};
export type { AddLockyIntegrationCommand };
